// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"79":"8fa6d751","135":"c09bd71a","243":"2172f259","409":"84f32bfe","511":"03a460e6","620":"d47b8d85","723":"bb5f0a46","734":"ddf46661","786":"1371bde8"}[chunkId] + ".chunk.js";
};